export function useUserPermissions() {
  const { permissions } = storeToRefs(useAuthStore());
  const { hash } = useRouterUtilities();

  const routeHashMap = computed(() => {
    switch (unref(hash)) {
      case "#customers":
        return "customers";

      case "#vendors":
        return "vendors";

      case "#team-members":
        return "internal_users";

      default:
        return "users";
    }
  });

  const mapToApiKey = (routeKey) => {
    switch (routeKey) {
      case "customers":
        return "buyer";

      case "vendors":
        return "seller";

      case "internal_users":
        return "";

      default:
        return "";
    }
  };

  const canView = computed(() => {
    const currentRoute = routeHashMap.value;

    return permissions.value?.[currentRoute]?.view || false;
  });

  const canAdd = computed(() => {
    const currentRoute = routeHashMap.value;

    return permissions.value?.[currentRoute]?.add || false;
  });

  const canEdit = computed(() => {
    const currentRoute = routeHashMap.value;

    if (currentRoute === "users") return false;
    else return permissions.value?.[currentRoute]?.edit || false;
  });

  const canApprove = computed(() => {
    const currentRoute = routeHashMap.value;

    return permissions.value?.[currentRoute]?.approve || false;
  });

  const canReject = computed(() => {
    const currentRoute = routeHashMap.value;

    return permissions.value?.[currentRoute]?.reject || false;
  });

  const canActivate = computed(() => {
    const currentRoute = routeHashMap.value;

    return permissions.value?.[currentRoute]?.activate || false;
  });

  const canDeactivate = computed(() => {
    const currentRoute = routeHashMap.value;

    return permissions.value?.[currentRoute]?.deactivate || false;
  });

  return {
    routeHashMap,
    mapToApiKey,
    canView,
    canAdd,
    canEdit,
    canApprove,
    canReject,
    canActivate,
    canDeactivate,
  };
}
